
<template>
    <div class="d-flex flex-column w-100 gap-md" style="min-height: 100vh;">
        <nav-bar/>
        <div class="d-flex flex-xl-row flex-column flex-wrap w-75 mx-auto mt-5 p-md-5 p-3 gap-sm justify-content-center align-items-center" style="box-shadow: 0px 0px 2px 0px grey;background-color: white;" v-if="this.permissaoUsuario != null">
        <router-link to="/arquivo/arquivos" class="card d-flex" v-if="false">
            <div class="px-1 d-flex flex-column">
                <h5>Arquivos</h5>
                <span>Baixe e Envie arquivos</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon style="font-size: 50px;" :icon="['fas', 'folder']" />
            </div>
        </router-link>
        <router-link to="/usuario/gerenciar-usuarios" class="card d-flex" v-if="permissaoUsuarioInterno">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">Gerenciar Usuários</h5>
                <span>Gerencie Usuários do Sistema</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon style="font-size: 50px;" icon="fa-solid fa-users-gear" />
            </div>
        </router-link>
        <router-link to="/pessoa/gerenciar-pessoas" class="card d-flex" v-if="permissaoUsuarioInterno">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">Gerenciar Pessoas</h5>
                <span>Gerencie pessoas do Sistema</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon style="font-size: 50px;" icon="fa-solid fa-people-line" />
            </div>
        </router-link>
        <router-link to="/arquivo/gerenciar-arquivos-usuarios" class="card d-flex" v-if="false">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">Gerenciar Arquivos de Usuários</h5>
                <span>Gerencie arquivos que são disponibilizados ao usuário</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon style="font-size: 50px;"
                :icon="['fas', 'file']" />
            </div>
        </router-link>
        <router-link to="/arquivo/gerenciar-arquivos-primeseg" class="card d-flex"  v-if="false">
            <div class="px-1 d-flex flex-column">
                <h5>Gerenciar Arquivos Primeseg</h5>
                <span>Gerencie arquivos que os clientes enviaram</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon style="font-size: 50px;"
                :icon="['fas', 'file']" />
            </div>
        </router-link>
        <router-link to="/agendamento/realizar-agendamento" class="card d-flex">
            <div class="px-1 d-flex flex-column">
                <h5>Agendamento</h5>
                <span>Agende os exames dos seus funcionários com a primeseg</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon :icon="['fas', 'calendar-days']" style="font-size: 50px;"/>
            </div>
        </router-link>
        <router-link to="/agendamento/gerenciar-agendamentos" class="card d-flex" v-if="permissaoUsuarioInterno">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">Gerenciar Agendamentos</h5>
                <span>Agenda/Solicitações</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon :icon="['fas', 'calendar-plus']" style="font-size: 50px;"/>
            </div>
        </router-link>
        <router-link to="/cat/enviar-cat" class="card d-flex">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">CAT</h5>
                <span>Comunicação de Acidente de Trabalho</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon :icon="['fas', 'file-circle-exclamation']" style="font-size: 50px;" />
            </div>
        </router-link>
        <router-link to="/cat/gerenciar-cat" class="card d-flex" v-if="permissaoUsuarioInterno">
            <div class="px-1 d-flex flex-column">
                <h5 class="px-1">Gerenciar CAT</h5>
                <span>Gerenciar Comunicados de Acidentes de Trabalho</span>
            </div>
            <div class="d-flex h-100 px-4 icon-area">
                <font-awesome-icon :icon="['fas', 'file-shield']" style="font-size: 50px;"/>
            </div>
        </router-link>
        </div>
    </div>
</template>

<script>
import NavBar from "../components/shared/NavBar.vue";


export default{
	components: { NavBar },
	name: "Login",
	data() {
		return {
			tamanhoDaTela: window.screen.width,
			permissaoUsuario: null,
			usuarioLogado: JSON.parse(localStorage.getItem("usuario")),
			carregando: false,
		};
	},
	created() {
		this.setaPermissaoUsuario();
	},
	computed: {
		permissaoUsuarioInterno() {
			return this.permissaoUsuario === "ADMINISTRADOR";
		},
	},
	methods: {
		setaPermissaoUsuario() {
			this.permissaoUsuario = this.$options.filters.checkPermissao();
		},

	},
};
</script>

<style scoped>

.icon-area{
    justify-content: center;
    background-color: #2BD6A5;
    align-items: center;
    width: 25% !important;
}
a{
    text-decoration: none !important;
    color: rgb(0, 0, 0) !important;
}
.card{
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 28%;
    height: 150px;
    transition: all ease 0.4s;
}

.card:hover{
    background: rgb(207, 207, 207, 0.3);
}

@media screen and (max-width:1200px){
    .card{
        width: 98% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue